import ko from 'knockout';

export function registerComponent() {
  ko.components.register('persons-picker', {
    template: { element: 'persons-picker-template' },
    viewModel: {
      createViewModel: function (params, componentInfo) {
        return new PersonsPickerViewModel(params, componentInfo);
      },
    },
  });
}

function PersonsPickerViewModel(params) {
  var self = this;

  var persons = params.Persons;

  var minNumberOfAdults = 0;
  var maxNumberOfAdults = 40;
  var minNumberOfChildren = 0;
  var maxNumberOfChildren = 40;

  self.Adults = persons.Adults;
  self.Children = persons.Children;
  self.ChildAges = persons.ChildAges;
  self.Errors = persons.Errors;
  self.content = ko.observable();

  self.Children.subscribe(setContent);
  self.Adults.subscribe(setContent);

  setContent();

  self.addAdult = function () {
    if (self.adults() < maxNumberOfAdults) {
      self.adults(parseInt(self.adults()) + 1);
    }
  };

  self.removeAdult = function () {
    if (self.adults() > minNumberOfAdults) {
      self.adults(self.adults() - 1);
    }
  };

  self.addChild = function () {
    if (self.children() < maxNumberOfChildren) {
      self.children(parseInt(self.children()) + 1);
    }
  };

  self.removeChild = function () {
    if (self.children() > minNumberOfChildren) {
      self.children(self.children() - 1);
    }
  };

  self.hasError = ko.pureComputed(function () {
    return self.Errors().length > 0;
  }, self);

  function setContent() {
    if (!self.Adults()) {
      self.content('&nbsp;');
    } else if (self.Children() == 0) {
      self.content(self.Adults() + ' personen');
    } else {
      self.content((parseInt(self.Adults()) + parseInt(self.Children())) + ' personen');
    }
  }
}

//      <span class="selector-text"><span class="travelparty-sum">3</span> <span class="sum-subject" data-single="persoon" data-multiple="personen">personen</span></span>7
